import { App } from "../Enums/App";
import {
    GetUSAWKTFailureAction,
    GetUSAWKTInitiateAction,
    GetUSAWKTSuccessAction,
    GetRedirectLinkInitiateAction,
    GetRedirectLinkFailureAction,
    GET_USA_WKT_FAILURE,
    GET_USA_WKT_INITIATE,
    GET_USA_WKT_SUCCESS,
    GET_REDIRECT_LINK_INITIATE,
    GET_REDIRECT_LINK_FAILURE,
} from "../Types/CommonActionTypes";

export const getUSAWKT = (): GetUSAWKTInitiateAction => ({
    type: GET_USA_WKT_INITIATE,
});

export const setUSAWKT = (wkt: string): GetUSAWKTSuccessAction => ({
    type: GET_USA_WKT_SUCCESS,
    data: wkt,
});

export const getUSAWKTFailure = (error: string): GetUSAWKTFailureAction => ({
    type: GET_USA_WKT_FAILURE,
    data: error,
});

export const getRedirectLinkInitiate = (appName: string): GetRedirectLinkInitiateAction => ({
    type: GET_REDIRECT_LINK_INITIATE,
    data: appName,
});

export const getRedirectLinkFailure = (error: string): GetRedirectLinkFailureAction => ({
    type: GET_REDIRECT_LINK_FAILURE,
    data: error,
});